import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import './index.css'
import { RegisterScreen } from './RegisterScreen.tsx'
import { ScenarioRegistrationPage } from './registration/ScenarioRegistrationFlow.tsx'
import { InviteScreen } from './InviteScreen.tsx'
import { AbpProvider } from './platform/abp/react.tsx'
import { OperatorSessionProvider } from './platform/buxus/OperatorSessionContext.tsx'
import { ErrorModalProvider } from './platform/ui/ErrorModalProvider.tsx'
import { initAnalytics, trackAppStartedIfNeeded } from './platform/analytics/analytics'
import { initWebErrorReporting, WebErrorBoundary } from './platform/errors/webErrorReporting'
import { startBrowserChromeThemeLock } from './platform/ui/browserChromeTheme'
import { AppShellRoute } from './routing/AppShellRoute'
import { LoginRoute } from './routing/LoginRoute'
import { LoginStartRoute } from './routing/LoginStartRoute'
import { OidcBootstrapGate } from './routing/OidcBootstrapGate'
import { ScenariosPocRoute } from './routing/ScenariosPocRoute'

function start() {
  startBrowserChromeThemeLock()
  initWebErrorReporting()
  initAnalytics()
  trackAppStartedIfNeeded()

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <WebErrorBoundary>
      <BrowserRouter>
        <ErrorModalProvider>
          <OidcBootstrapGate>
          <AbpProvider>
            <OperatorSessionProvider>
              {/*
                /login — full login screen (Register, Operator login, help).
                /login/start — session check, then IdP redirect (marketing “Log in” links).
                /register — registration (browser canonical).
                /user/register — legacy buxusweb / deployed mobile WebView entry (same screen; do not redirect).
                /user/invite — legacy mobile Profile “Invite Responders” WebView entry.
                /user/login, /user — legacy redirects to login.
                /user/register keeps ?query for referral / express deep links.
                /* — signed-in app shell; unknown paths 404 (not login).
              */}
              <Routes>
                <Route path="/login/start" element={<LoginStartRoute />} />
                <Route path="/login" element={<LoginRoute />} />
                <Route path="/register/scenarios" element={<ScenarioRegistrationPage />} />
                <Route path="/register" element={<RegisterScreen />} />
                <Route path="/user/login" element={<Navigate to="/login" replace />} />
                <Route path="/user" element={<Navigate to="/login" replace />} />
                <Route path="/user/register" element={<RegisterScreen />} />
                <Route path="/user/invite" element={<InviteScreen />} />
                <Route path="/auth/callback" element={<Navigate to="/" replace />} />
                {/* Scenario Studio — splat keeps one mounted element for /scenarios and /scenarios/<id> */}
                <Route path="/scenarios/*" element={<ScenariosPocRoute />} />
                <Route path="/*" element={<AppShellRoute />} />
              </Routes>
            </OperatorSessionProvider>
          </AbpProvider>
          </OidcBootstrapGate>
        </ErrorModalProvider>
      </BrowserRouter>
      </WebErrorBoundary>
    </StrictMode>,
  )
}

void start()
